import React, { useEffect, useState } from "react";
import { IoIosArrowForward } from "react-icons/io";
import { BsPlusSquareFill } from "react-icons/bs";
import { CiCircleMinus, CiCirclePlus } from "react-icons/ci";
import { Link, useNavigate } from "react-router-dom";
import {
  ChangeTitle,
  formatPrice,
  selectFormStyle,
  toAbsoluteUrl,
  toasterrormsg,
  toastsuccessmsg,
  typeList,
} from "../../helpers/Reusable";
import * as Yup from "yup";
import { useFormik } from "formik";
import { ToastContainer } from "react-toastify";
import ClipLoader from "react-spinners/ClipLoader";
import { IoClose } from "react-icons/io5";
import Select from "react-select";
import {
  apiHeader,
  deleteData,
  getData,
  postData,
} from "../../helpers/ApiHelper";
import { getCookie, setCookie } from "../../helpers/CookieComponent";

const onlyIntRegExp = /^[0-9+]+$/;
const onlyAlphabet = /^[A-Za-z][A-Za-z\s]+$/;

// Formik InitialValues
const initialValuesAddress = {
  addressId: "",
  fullName: "",
  mobileNumber: "",
  designation: "",
  companyName: "",
  flatFloorNo: "",
  streetRoadNo: "",
  location: "",
  country: "",
  pinCode: "",
  city: "",
  addressType: "",
  type: "Shipping",
};

// Fromik Validation Schema
const schemaAddress = Yup.object().shape({
  fullName: Yup.string()
    .trim()
    .required("Full name is required")
    .matches(onlyAlphabet, "Full name is not valid"),
  mobileNumber: Yup.string()
    .trim()
    .required("Mobile number is required")
    .matches(onlyIntRegExp, "Mobile number is not valid")
    .min(10, "Mobile number is not valid")
    .max(16, "Mobile number is not valid"),
  designation: Yup.string().trim().required("Select designation"),
  companyName: Yup.string()
    .trim()
    .required("Company name is required")
    .matches(onlyAlphabet, "Company name is not valid"),
  flatFloorNo: Yup.string().trim().required("Flat / Floor No. is required"),
  streetRoadNo: Yup.string().trim().required("Street / Road No. is required"),
  country: Yup.string().trim().required("Select country"),
  location: Yup.string().trim().required("Location is required"),
  pinCode: Yup.string()
    .trim()
    .required("Pin code is required")
    .matches(onlyIntRegExp, "Pin code is not valid")
    .min(4, "Pin code is not valid")
    .max(14, "Pin code is not valid"),
  city: Yup.string().trim().required("City is required"),
  addressType: Yup.string().trim().required("Select address type"),
  type: Yup.string().trim().required("Select Address type"),
});

// Formik InitialValues
const initialValuesGst = {
  entityName: "",
  typeOfBusiness: "",
  panOfBusiness: "",
  gstNumber: "",
  // country: "",
  state: "",
  address: "",
};

// Fromik Validation Schema
const schemaGst = Yup.object().shape({
  entityName: Yup.string()
    .trim()
    .required("Entity name is required")
    .matches(onlyAlphabet, "Entity name is not valid"),
  typeOfBusiness: Yup.string().trim().required("Select type of business"),
  panOfBusiness: Yup.string()
    .trim()
    .required("Pan number is required")
    .matches(/^([A-Z]{5}[0-9]{4}[A-Z]{1})$/, "Pan number is not valid"),
  gstNumber: Yup.string()
    .trim()
    .required("GSTIN number is required")
    .matches("", "GSTIN number is not valid"),
  state: Yup.string().trim().required("Select state"),
  // country: Yup.string().trim().required("Select Country"),
  address: Yup.string().trim().required("Address is required"),
});

const BooksSingleBilling = () => {
  ChangeTitle("Billing");
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
  const [isGstModalOpen, setIsGstModalOpen] = useState(false);
  const [loadingAddress, setLoadingAddress] = useState(false);
  const [loadingGst, setLoadingGst] = useState(false);
  const [addressList, setAddressList] = useState([]);
  const [designationList, setDesignationList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [bisunessTypeList, setBusinessTypeList] = useState([]);
  const [bookDetail, setBookDetail] = useState({});
  const [gstDetail, setGstDetail] = useState([]);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [liveQuantity, setLiveQuantity] = useState("");
  const navigate = useNavigate();
   const [selectedShippingAddressId, setSelectedShippingAddressId] =
     useState(null);
   const [selectedBillingAddressId, setSelectedBillingAddressId] =
     useState(null);
   const [sameAsBillingId, setSameAsBillingId] = useState(null);


  // const handleProceedToPay = () => {
  //   if (!selectedAddressId) {
  //     toasterrormsg("Please select or add an address");
  //     return;
  //   }

  //   navigate("/books/payment");
  // };
    const handleProceedToPay = () => {
      const finalBillingAddressId = sameAsBillingId || selectedBillingAddressId;

      console.log(selectedShippingAddressId, "selectedShippingAddressId");
      console.log(finalBillingAddressId, "finalBillingAddressId");

      if (!selectedShippingAddressId) {
        toasterrormsg("Please select or add a shipping address");
        return;
      }

      if (!finalBillingAddressId) {
        toasterrormsg("Please select or add a billing address");
        return;
      }

      setCookie("selected-billing-address-id", finalBillingAddressId, {});
      navigate("/books/payment");
    };


  const booksId = getCookie("b-billingId");
  const currency = getCookie("b-plan-currency");
  const quantity = getCookie("b-qty");

  useEffect(() => {
    if (quantity) {
      setLiveQuantity(quantity);
    }
  }, [quantity]);

  // Function to handle incrementing quantity
  const incrementQuantity = () => {
    const updatedQty = Number(quantity) + 1;
    setLiveQuantity(updatedQty);
    setCookie("b-qty", updatedQty, {});
    viewBooksDetail(booksId, updatedQty, "", currency);
  };

  // Function to handle decrementing quantity
  const decrementQuantity = () => {
    if (liveQuantity > 1) {
      const updatedQty = Number(quantity) - 1;
      setLiveQuantity(updatedQty);
      setCookie("b-qty", updatedQty, {});
      viewBooksDetail(booksId, updatedQty, "", currency);
    }
  };

  const handleSameAsBilling = (checked, shippingId) => {
    if (checked) {
      setSameAsBillingId(shippingId);
      setSelectedBillingAddressId(null);
    } else {
      setSameAsBillingId(null);
      // Re-select default billing address when unchecked
      const billingAddresses = addressList.filter(
        (item) => item.type === "Billing"
      );
      if (billingAddresses.length > 0) {
        const defaultBilling =
          billingAddresses.find((item) => item.addressType === "default") ||
          billingAddresses[0];
        setSelectedBillingAddressId(defaultBilling._id);
      }
    }
  };

  // Add Address Api Call
  const formikAddress = useFormik({
    initialValues: initialValuesAddress,
    validationSchema: schemaAddress,
    onSubmit: async (values, { resetForm }) => {
      setLoadingAddress(true);

      const param = {
        addressId: values.addressId,
        fullName: values.fullName,
        mobileNumber: values.mobileNumber,
        designationId: values.designation,
        companyName: values.companyName,
        flatFloorNo: values.flatFloorNo,
        streetRoadNo: values.streetRoadNo,
        location: values.location,
        countryId: values.country,
        pincode: values.pinCode,
        city: values.city,
        addressType: values.addressType, //"default","home","office"
        type: values.type,
      };

      console.log(param);

      const response = await postData(
        "private/user/address",
        param,
        apiHeader(false)
      );

      if (
        String(response?.status) == "200" &&
        String(response?.data.status) == "200"
      ) {
        toastsuccessmsg(response.data.message);
        viewAddressList();
        setTimeout(() => {
          setLoadingAddress(false);
          resetForm();
          closeModal("address");
        }, 1500);
      } else {
        console.log(response.data.message);
        toasterrormsg(response.data.message);
        setLoadingAddress(false);
      }
    },
  });

  // Edit Gst Api Call
  const formikGst = useFormik({
    initialValues: initialValuesGst,
    validationSchema: schemaGst,
    onSubmit: async (values, { resetForm }) => {
      setLoadingGst(true);

      const param = {
        entityName: values.entityName,
        typeOfBusinessId: values.typeOfBusiness,
        panOfBusiness: values.panOfBusiness,
        gstinNumber: values.gstNumber,
        state: values.state,
        address: values.address,
      };

      const response = await postData(
        "private/user/taxidentificationnumber",
        param,
        apiHeader(false)
      );

      if (
        String(response?.status) == "200" &&
        String(response?.data.status) == "200"
      ) {
        toastsuccessmsg(response.data.message);
        viewAddressList();
        setTimeout(() => {
          setLoadingGst(false);
          closeModal("gst");
        }, 1500);
      } else {
        console.log(response.data.message);
        toasterrormsg(response.data.message);
        setLoadingGst(false);
      }
    },
  });

  // Get Address API Call
  const getAddressDetail = async (id) => {
    const param = {
      addressId: id,
    };
    var response = await postData(
      "private/user/address/detail",
      param,
      apiHeader(false)
    );

    console.log("address get", response);

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data;
      formikAddress.setValues({
        addressId: data._id,
        fullName: data.fullName,
        mobileNumber: data.mobileNumber,
        designation: data.designationId,
        companyName: data.companyName,
        flatFloorNo: data.flatFloorNo,
        streetRoadNo: data.streetRoadNo,
        location: data.location,
        country: data.countryId,
        pinCode: data.pincode,
        city: data.city,
        addressType: data.addressType,
        type: data.type,
      });
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Address API Call
  const viewAddressList = async () => {
    const param = {};
    var response = await getData(
      "private/user/address/list",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data;
       setAddressList(data);
       // Set default shipping address
       const shippingAddresses = data.filter(
         (item) => item.type === "Shipping"
       );
       if (shippingAddresses.length > 0) {
         const defaultShipping =
           shippingAddresses.find((item) => item.addressType === "default") ||
           shippingAddresses[0];
         setSelectedShippingAddressId(defaultShipping._id);
       }
       // Set default billing address
       const billingAddresses = data.filter((item) => item.type === "Billing");
       if (billingAddresses.length > 0) {
         const defaultBilling =
           billingAddresses.find((item) => item.addressType === "default") ||
           billingAddresses[0];
         setSelectedBillingAddressId(defaultBilling._id);
       }
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Designation API Call
  const viewDesignationList = async () => {
    const param = {};
    var response = await postData("designation/list", param, apiHeader(false));

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const listData = data.map((data) => {
        return {
          value: data._id,
          label: data.designationName,
        };
      });
      setDesignationList(listData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Business Type List  API Call
  const viewBusinessTypeList = async () => {
    const param = {};
    var response = await getData(
      "private/typeofbusiness/list",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const listData = data.map((data) => {
        return {
          value: data._id,
          label: data.typeOfBusiness,
        };
      });
      setBusinessTypeList(listData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // County List  API Call
  const viewCountryList = async () => {
    const param = {};
    var response = await postData(
      "country/list",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const listData = data.map((data) => {
        return {
          value: data._id,
          label: data.countryName,
        };
      });
      setCountryList(listData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // State List  API Call
  const viewStateList = async (id) => {
    const param = {
      countryId: id,
    };
    var response = await postData(
      "private/state/list",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const listData = data.map((data) => {
        return {
          value: data._id,
          label: data.stateName,
        };
      });
      setStateList(listData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Plan Detail API Call
  const viewBooksDetail = async (id, qty, promoCode, currency) => {
    const param = {
      bookId: id,
      quantity: qty,
      promoCode: promoCode,
      currency: currency,
    };
    var response = await postData(
      "private/order/direct/buy/preview",
      param,
      apiHeader(false)
    );

    console.log("plan detail billing param", param);
    console.log("plan detail billing", response);

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data;
      setBookDetail(data);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // GST Detail API Call
  const viewGstDetail = async () => {
    const param = {};
    var response = await getData(
      "private/user/taxidentificationnumber/detail",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data;
      setGstDetail(data);
      if (data.length != 0) {
        const values = response.data.data[0];

        formikGst.setValues({
          entityName: values.entityName,
          typeOfBusiness: values?.typeOfBusinessDetail?._id,
          panOfBusiness: values.panOfBusiness,
          gstNumber: values.gstinNumber,
          country: values.country,
          state: values.state,
          address: values.address,
        });
      }
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // GST Delete API Call
  const deleteGstDetail = async (id) => {
    const param = {
      taxIndentificationNumberId: id,
    };
    console.log(param, "param");

    var response = await deleteData(
      "private/user/taxidentificationnumber/delete",
      param,
      apiHeader(false)
    );
    console.log(response);

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      toastsuccessmsg(response.message);
      viewGstDetail();
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  useEffect(() => {
    if (formikAddress.values.addressId) {
      getAddressDetail(formikAddress.values.addressId);
    }
  }, [formikAddress.values.addressId]);

  useEffect(() => {
    viewStateList(formikGst.values.country);
  }, [formikGst.values.country]);

  useEffect(() => {
    viewBooksDetail(booksId, quantity, "", currency);
  }, [booksId, quantity, currency]);

  useEffect(() => {
    viewAddressList();
    viewDesignationList();
    viewCountryList();
    viewGstDetail();
    viewBusinessTypeList();
  }, []);


  // Shipping Address Select Handle Function
  const handleShippingAddressSelect = (id) => {
    setSelectedShippingAddressId(id);
    setCookie("selected-shipping-address-id", id, {});
  };

  // Billing Address Select Handle Function
  const handleBillingAddressSelect = (id) => {
    setSelectedBillingAddressId(id);
    setCookie("selected-billing-address-id", id, {});
  };

  useEffect(() => {
    if (selectedShippingAddressId) {
      setCookie("selected-shipping-address-id", selectedShippingAddressId, {});
    }
  }, [selectedShippingAddressId]);

  useEffect(() => {
    if (selectedBillingAddressId) {
      setCookie("selected-billing-address-id", selectedBillingAddressId, {});
    }
  }, [selectedBillingAddressId]);

  // Opem Modal Popup Form Function
  const openModal = (type) => {
    document.body.style.overflowY = "hidden";
    if (type == "address") {
      setIsAddressModalOpen(true);
    } else if (type == "gst") {
      setIsGstModalOpen(true);
    }
  };
  // Close Modal Popup Form Function
  const closeModal = (type) => {
    document.body.style.overflowY = "";
    if (type == "address") {
      setIsAddressModalOpen(false);
      formikAddress.resetForm();
    } else if (type == "gst") {
      setIsGstModalOpen(false);
    }
  };

  return (
    <>
      <ToastContainer />
      {isAddressModalOpen === true && (
        <>
          <div
            onClick={() => closeModal("address")}
            className={`w-full fixed top-0 z-[9999] h-screen overflow-x-hidden overflow-y-auto bg-form getintouch`}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="w-[90%] md:w-[80%] lg:w-[70%] xl:w-[60%] xxl:container p-[2%] mx-auto my-[6%] relative  transform form-box"
            >
              <div className="flex items-center justify-between">
                <h1 className="mb-[3%] hanson">Address</h1>
                <IoClose
                  onClick={() => closeModal("address")}
                  className="w-[3rem] h-[3rem] cursor-pointer"
                />
              </div>
              <div className="">
                <form onSubmit={formikAddress.handleSubmit}>
                  <div className="w-full grid lg:grid-cols-2 gap-[2rem] gap-y-[1rem] mb-[2rem]">
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor="type"
                        className="w-full form-input-label required mb-4"
                      >
                        Address Type
                      </label>
                      <Select
                        name="type"
                        id="type"
                        placeholder="Select Address Type"
                        className="w-full form-select form-input"
                        isSearchable={true}
                        options={typeList}
                        value={typeList.find(
                          (item) => item.value === formikAddress.values.type
                        )}
                        onChange={(e) =>
                          formikAddress.setFieldValue("type", e.value)
                        }
                        styles={selectFormStyle}
                      />
                      {formikAddress.touched.type &&
                        formikAddress.errors.type && (
                          <div className="mt-2 error-msg">
                            <div className="">{formikAddress.errors.type}</div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Full name
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter full name"
                        name="fullName"
                        id="fullName"
                        value={formikAddress.values.fullName}
                        onChange={formikAddress.handleChange}
                      />
                      {formikAddress.touched.fullName &&
                        formikAddress.errors.fullName && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikAddress.errors.fullName}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Mobile number
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter mobile number"
                        id="mobileNumber"
                        value={formikAddress.values.mobileNumber}
                        onChange={formikAddress.handleChange}
                      />
                      {formikAddress.touched.mobileNumber &&
                        formikAddress.errors.mobileNumber && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikAddress.errors.mobileNumber}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Designation
                      </label>
                      <Select
                        name="designation"
                        id="designation"
                        placeholder="Select designation"
                        className="w-full form-select form-input"
                        isSearchable={true}
                        options={designationList}
                        value={designationList.find(
                          (item) =>
                            item.value === formikAddress.values.designation
                        )}
                        onChange={(e) =>
                          formikAddress.setFieldValue("designation", e.value)
                        }
                        styles={selectFormStyle}
                      />
                      {formikAddress.touched.designation &&
                        formikAddress.errors.designation && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikAddress.errors.designation}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Company name
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter company name"
                        name="companyName"
                        id="companyName"
                        value={formikAddress.values.companyName}
                        onChange={formikAddress.handleChange}
                      />
                      {formikAddress.touched.companyName &&
                        formikAddress.errors.companyName && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikAddress.errors.companyName}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Flat / Floor No.
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter flat / floor no"
                        name="flatFloorNo"
                        id="flatFloorNo"
                        value={formikAddress.values.flatFloorNo}
                        onChange={formikAddress.handleChange}
                      />
                      {formikAddress.touched.flatFloorNo &&
                        formikAddress.errors.flatFloorNo && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikAddress.errors.flatFloorNo}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Street / Road No
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter street / road no"
                        name="streetRoadNo"
                        id="streetRoadNo"
                        value={formikAddress.values.streetRoadNo}
                        onChange={formikAddress.handleChange}
                      />
                      {formikAddress.touched.streetRoadNo &&
                        formikAddress.errors.streetRoadNo && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikAddress.errors.streetRoadNo}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Location
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter location"
                        name="location"
                        id="location"
                        value={formikAddress.values.location}
                        onChange={formikAddress.handleChange}
                      />
                      {formikAddress.touched.location &&
                        formikAddress.errors.location && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikAddress.errors.location}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Country
                      </label>
                      <Select
                        name="country"
                        id="country"
                        placeholder="Select country"
                        className="w-full form-select form-input"
                        isSearchable={true}
                        options={countryList}
                        value={countryList.find(
                          (item) => item.value === formikAddress.values.country
                        )}
                        onChange={(e) =>
                          formikAddress.setFieldValue("country", e.value)
                        }
                        styles={selectFormStyle}
                      />
                      {formikAddress.touched.country &&
                        formikAddress.errors.country && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikAddress.errors.country}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Pin Code
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter pin code"
                        id="pinCode"
                        value={formikAddress.values.pinCode}
                        onChange={formikAddress.handleChange}
                      />
                      {formikAddress.touched.pinCode &&
                        formikAddress.errors.pinCode && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikAddress.errors.pinCode}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        City
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter city"
                        name="city"
                        id="city"
                        value={formikAddress.values.city}
                        onChange={formikAddress.handleChange}
                      />
                      {formikAddress.touched.city &&
                        formikAddress.errors.city && (
                          <div className="mt-2 error-msg">
                            <div className="">{formikAddress.errors.city}</div>
                          </div>
                        )}
                    </div>
                    <div className="w-full lg:col-span-2 flex flex-col">
                      <div className="w-full flex flex-wrap flex-row gap-5 md:gap-10 mb-auto">
                        <div className="flex gap-3 items-center form-checkbox">
                          <input
                            type="radio"
                            name="addressType"
                            value="default"
                            checked={
                              formikAddress.values.addressType === "default"
                            }
                            onChange={() =>
                              formikAddress.setFieldValue(
                                "addressType",
                                "default"
                              )
                            }
                            className="w-[2rem] h-[2rem] form-input accent-[#2C3451]"
                          />
                          <label htmlFor="" className="checkbox-label">
                            This is my default address
                          </label>
                        </div>
                        <div className="flex gap-3 items-center form-checkbox">
                          <input
                            type="radio"
                            name="addressType"
                            value="home"
                            checked={
                              formikAddress.values.addressType === "home"
                            }
                            onChange={() =>
                              formikAddress.setFieldValue("addressType", "home")
                            }
                            className="w-[2rem] h-[2rem] form-input accent-[#2C3451]"
                          />
                          <label htmlFor="" className="checkbox-label">
                            Home
                          </label>
                        </div>
                        <div className="flex gap-3 items-center form-checkbox">
                          <input
                            type="radio"
                            name="addressType"
                            value="office"
                            checked={
                              formikAddress.values.addressType === "office"
                            }
                            onChange={() =>
                              formikAddress.setFieldValue(
                                "addressType",
                                "office"
                              )
                            }
                            className="w-[2rem] h-[2rem] form-input accent-[#2C3451]"
                          />
                          <label htmlFor="" className="checkbox-label">
                            Office
                          </label>
                        </div>
                      </div>
                      {formikAddress.touched.addressType &&
                        formikAddress.errors.addressType && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikAddress.errors.addressType}
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="w-full justify-center gap-5 flex">
                    <button
                      type="submit"
                      className="btn-submit"
                      disabled={loadingAddress}
                    >
                      {!loadingAddress && <>Save</>}
                      {loadingAddress && (
                        <div className="flex items-center gap-3">
                          <span className="" style={{ display: "block" }}>
                            Please wait...{" "}
                          </span>
                          <ClipLoader
                            color={"#ffffff"}
                            loading={loadingAddress}
                            size={20}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </div>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      )}
      {isGstModalOpen === true && (
        <>
          <div
            onClick={() => closeModal("gst")}
            className={`w-full fixed top-0 z-[9999] h-screen overflow-x-hidden overflow-y-auto bg-form getintouch`}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="w-[90%] md:w-[80%] lg:w-[70%] xl:w-[60%] xxl:container p-[2%] mx-auto my-[5%] xl:my-0 relative xl:top-1/2 transform xl:-translate-y-1/2 form-box"
            >
              <div className="flex items-center justify-between">
                <h1 className="mb-[3%] hanson">GSTIN Details</h1>
                <IoClose
                  onClick={() => closeModal("gst")}
                  className="w-[3rem] h-[3rem] cursor-pointer"
                />
              </div>
              <div className="">
                <form onSubmit={formikGst.handleSubmit}>
                  <div className="w-full grid lg:grid-cols-2 gap-[2rem] gap-y-[1rem] mb-[2rem]">
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Legal name of the entity
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter legal name of the entity"
                        name="entityName"
                        id="entityName"
                        value={formikGst.values.entityName}
                        onChange={formikGst.handleChange}
                      />
                      {formikGst.touched.entityName &&
                        formikGst.errors.entityName && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikGst.errors.entityName}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Type of business
                      </label>
                      <Select
                        name="typeOfBusiness"
                        id="typeOfBusiness"
                        placeholder="Select type of business"
                        className="w-full form-select form-input"
                        isSearchable={true}
                        options={bisunessTypeList}
                        value={bisunessTypeList.find(
                          (item) =>
                            item.value === formikGst.values.typeOfBusiness
                        )}
                        onChange={(e) =>
                          formikGst.setFieldValue("typeOfBusiness", e.value)
                        }
                        styles={selectFormStyle}
                      />
                      {formikGst.touched.typeOfBusiness &&
                        formikGst.errors.typeOfBusiness && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikGst.errors.typeOfBusiness}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Pan of the business
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter pan of the business"
                        name="panOfBusiness"
                        id="panOfBusiness"
                        value={formikGst.values.panOfBusiness}
                        onChange={formikGst.handleChange}
                      />
                      {formikGst.touched.panOfBusiness &&
                        formikGst.errors.panOfBusiness && (
                          <div className="mt-2 error-msg">
                            <div className="">
                              {formikGst.errors.panOfBusiness}
                            </div>
                          </div>
                        )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        GSTIN number
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter GSTIN number"
                        name="gstNumber"
                        id="gstNumber"
                        value={formikGst.values.gstNumber}
                        onChange={formikGst.handleChange}
                      />
                      {formikGst.touched.gstNumber &&
                        formikGst.errors.gstNumber && (
                          <div className="mt-2 error-msg">
                            <div className="">{formikGst.errors.gstNumber}</div>
                          </div>
                        )}
                    </div>
                    {/* <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Country
                      </label>
                      <Select
                        name="country"
                        id="country"
                        placeholder="Select Country"
                        className="w-full form-select form-input"
                        isSearchable={true}
                        options={countryList}
                        value={countryList.find(
                          (item) => item.value === formikGst.values.country
                        )}
                        onChange={(e) =>
                          formikGst.setFieldValue("country", e.value)
                        }
                        styles={selectFormStyle}
                      />
                      {formikGst.touched.country &&
                        formikGst.errors.country && (
                          <div className="mt-2 error-msg">
                            <div className="">{formikGst.errors.country}</div>
                          </div>
                        )}
                    </div> */}
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        State
                      </label>
                      <Select
                        name="state"
                        id="state"
                        placeholder="Select state"
                        className="w-full form-select form-input"
                        isSearchable={true}
                        options={stateList}
                        value={stateList.find(
                          (item) => item.value === formikGst.values.state
                        )}
                        onChange={(e) =>
                          formikGst.setFieldValue("state", e.value)
                        }
                        styles={selectFormStyle}
                      />
                      {formikGst.touched.state && formikGst.errors.state && (
                        <div className="mt-2 error-msg">
                          <div className="">{formikGst.errors.state}</div>
                        </div>
                      )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Address
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter address"
                        name="address"
                        id="address"
                        value={formikGst.values.address}
                        onChange={formikGst.handleChange}
                      />
                      {formikGst.touched.address &&
                        formikGst.errors.address && (
                          <div className="mt-2 error-msg">
                            <div className="">{formikGst.errors.address}</div>
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="w-full justify-center gap-5 flex">
                    <button
                      type="submit"
                      className="btn-submit"
                      disabled={loadingGst}
                    >
                      {!loadingGst && <>Save</>}
                      {loadingGst && (
                        <div className="flex items-center gap-3">
                          <span className="" style={{ display: "block" }}>
                            Please wait...{" "}
                          </span>
                          <ClipLoader
                            color={"#ffffff"}
                            loading={loadingGst}
                            size={20}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </div>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      )}
      <div className="w-full p-[3%] billing-address-main">
        <div className="xxl:container mx-auto">
          <div className="w-full flex items-center justify-center lg:justify-start mb-[2%] bam-status">
            <div className="w-max bams-box">
              <div className="w-auto mx-auto mb-[10%] flex items-center justify-center px-[2%] py-[5%] text-center no">
                <h1>1</h1>
              </div>
              <div className="title">Address</div>
            </div>
            <div className="w-[50%] sm:w-[25%] md:w-[30%] lg:w-[15%] xl:w-[10%] mt-[-5%] md:mt-[-2%] bams-box-line"></div>
            <div className="w-max bams-box bams-box2">
              <div className="w-auto mx-auto mb-[5%] flex items-center justify-center px-[2%] py-[5%] text-center no no2">
                <h1>2</h1>
              </div>
              <div className="title title2">Payment</div>
            </div>
          </div>
          <div className="w-full flex flex-col lg:flex-row gap-10 address-details">
            <div className="w-full lg:w-[70%] h-max p-[3%] sm:p-[2%] md:p-[1%] ad-part1">
              <div className="w-full billing-address">
                <div className="w-full mb-[1%] flex items-center justify-between">
                  <h1>Shipping address</h1>
                  <BsPlusSquareFill
                    onClick={() => openModal("address")}
                    className="text-3xl cursor-pointer"
                  />
                </div>
                {addressList.filter((item) => item.type === "Shipping")
                  .length !== 0 ? (
                  addressList
                    .filter((item) => item.type === "Shipping")
                    .map((data) => (
                      <div
                        className="flex justify-between items-start gap-5 mb-[5%] md:mb-[1%] w-full px-[2%] md:px-[1%] py-[2%] ba-box"
                        onClick={() => handleShippingAddressSelect(data._id)}
                      >
                        <div className="w-[2rem] h-[2rem] form-checkbox">
                          <input
                            type="radio"
                            name="shippingAddress"
                            value=""
                            checked={selectedShippingAddressId === data._id}
                            onChange={() =>
                              handleShippingAddressSelect(data._id)
                            }
                            className="w-[2rem] h-[2rem] form-input accent-[#2C3451]"
                          />
                        </div>
                        <div className="w-full flex justify-between items-start">
                          <div className="w-[70%]">
                            <div className="flex items-center gap-10 mb-[1%]">
                              <h1 className="name">{data.fullName}</h1>
                              <div
                                className="flex gap-2 items-center form-checkbox"
                                onClick={(e) => e.stopPropagation()}
                              >
                                <input
                                  type="checkbox"
                                  checked={sameAsBillingId === data._id}
                                  onChange={(e) =>
                                    handleSameAsBilling(
                                      e.target.checked,
                                      data._id
                                    )
                                  }
                                  className="w-[1.5rem] h-[1.5rem] form-input accent-[#2C3451]"
                                />
                                <label className="checkbox-label text-[14px] text-[#7c7474]">
                                  Same as billing
                                </label>
                              </div>
                            </div>
                            <h3 className="mb-[1%] address">
                              {data.flatFloorNo}, {data.streetRoadNo},{" "}
                              {data.location}, {data.city},{" "}
                              {data.countryDetail.countryName} - {data.pincode}
                            </h3>
                            <h3 className="mobileno">{data.mobileNumber}</h3>
                          </div>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              openModal("address");
                              formikAddress.setFieldValue(
                                "addressId",
                                data._id
                              );
                            }}
                            className="w-max mr-[2%] cursor-pointer"
                          >
                            <img
                              className=""
                              src={toAbsoluteUrl(
                                "media/img/icon/basic/pencile.svg"
                              )}
                              alt=""
                            />
                          </button>
                        </div>
                      </div>
                    ))
                ) : (
                  <>
                    <h3 className="mb-[1%] text-center no-found">
                      No address found
                    </h3>
                  </>
                )}
              </div>
              <div className="w-full billing-address">
                <div className="w-full mb-[1%] flex items-center justify-between">
                  <h1>Billing address</h1>
                </div>
                {sameAsBillingId ? (
                  <h3 className="mb-[1%] text-center no-found">
                    Using shipping address as billing address
                  </h3>
                ) : addressList.filter((item) => item.type === "Billing")
                    .length !== 0 ? (
                  addressList
                    .filter((item) => item.type === "Billing")
                    .map((data) => (
                      <div
                        className="flex justify-between items-start gap-5 mb-[5%] md:mb-[1%] w-full px-[2%] md:px-[1%] py-[2%] ba-box"
                        onClick={() => handleBillingAddressSelect(data._id)}
                        key={data._id}
                      >
                        <div className="w-[2rem] h-[2rem] form-checkbox">
                          <input
                            type="radio"
                            name="billingAddress"
                            value=""
                            checked={selectedBillingAddressId === data._id}
                            onChange={() =>
                              handleBillingAddressSelect(data._id)
                            }
                            className="w-[2rem] h-[2rem] form-input accent-[#2C3451]"
                          />
                        </div>
                        <div className="w-full flex justify-between items-start">
                          <div className="w-[70%]">
                            <h1 className="mb-[1%] name">{data.fullName}</h1>
                            <h3 className="mb-[1%] address">
                              {data.flatFloorNo}, {data.streetRoadNo},{" "}
                              {data.location}, {data.city},{" "}
                              {data.countryDetail.countryName} - {data.pincode}
                            </h3>
                            <h3 className="mobileno">{data.mobileNumber}</h3>
                          </div>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              openModal("address");
                              formikAddress.setFieldValue(
                                "addressId",
                                data._id
                              );
                            }}
                            className="w-max mr-[2%] cursor-pointer"
                          >
                            <img
                              className=""
                              src={toAbsoluteUrl(
                                "media/img/icon/basic/pencile.svg"
                              )}
                              alt=""
                            />
                          </button>
                        </div>
                      </div>
                    ))
                ) : (
                  <h3 className="mb-[1%] text-center no-found">
                    No address found
                  </h3>
                )}
              </div>
              <div className="w-full gstin-details">
                <div className="w-full mb-[1%]">
                  <h1>GSTIN details</h1>
                </div>
                {gstDetail.length != 0 ? (
                  gstDetail.map((data) => (
                    <div className="flex mb-[1%] justify-between items-center w-full  px-[2%] md:px-[1%] py-[2%] gd-box">
                      <div className="flex flex-col sm:flex-row justify-between gap-5 w-[70%]">
                        <div>
                          <h1 className="mb-[1%] title">Entity name:</h1>
                          <h3 className="mb-[1%] text">{data.entityName}</h3>
                        </div>
                        <div>
                          <h1 className="mb-[1%] title">Entity type:</h1>
                          <h3 className="mb-[1%] text">
                            Private limited company
                          </h3>
                        </div>
                        <div>
                          <h1 className="mb-[1%] title">GSTIN no.:</h1>
                          <h3 className="mb-[1%] text">{data.gstinNumber}</h3>
                        </div>
                      </div>
                      <div className="w-auto flex gd-icon">
                        <button onClick={() => openModal("gst")}>
                          <img
                            className="p-[1rem] w-max mr-[2%] cursor-pointer"
                            src={toAbsoluteUrl(
                              "media/img/icon/basic/pencile.svg"
                            )}
                            alt=""
                          />
                        </button>
                        <button onClick={() => deleteGstDetail(data._id)}>
                          <img
                            className="p-[1rem] w-max mr-[2%] cursor-pointer"
                            src={toAbsoluteUrl(
                              "media/img/icon/basic/trash.svg"
                            )}
                            alt=""
                          />
                        </button>
                      </div>
                    </div>
                  ))
                ) : (
                  <>
                    <h3 className="mb-[1%] no-found">
                      For Credit Purpose, Update{" "}
                      <Link to={"/mytaxidentification"} className="underline">
                        Tax Details
                      </Link>{" "}
                      In Your Profile.
                    </h3>
                  </>
                )}
              </div>
            </div>
            <div className="h-max w-[90%] sm:w-[60%] lg:w-[30%] mx-auto p-[3%] sm:px-[2%] sm:py-[2.5%] lg:px-[1%] lg:py-[1.5%] cart-summary">
              <h1 className="w-full mb-[2%] cs-h1">Cart summary</h1>
              <div className="w-full flex flex-col justify-between">
                <div className="w-full px-[3%] mb-[40%] py-[3.5%] cs-box1">
                  <div className="w-full">
                    <div className="flex gap-5 mb-5">
                      <img
                        className="w-[5rem] h-[5rem]"
                        src={
                          bookDetail &&
                          bookDetail.item &&
                          bookDetail.item.bookImage
                        }
                        alt=""
                      />
                      <div>
                        <h1 className="mb-[1%]">
                          {bookDetail &&
                            bookDetail.item &&
                            bookDetail.item.title}
                        </h1>
                        <h2 className="mb-[5%]">
                          {" "}
                          {/* {currencySymbol} */}
                          {currency}{" "}
                          {bookDetail &&
                            bookDetail.item &&
                            bookDetail.item.price &&
                            formatPrice(bookDetail.item.price, currency)}{" "}
                        </h2>
                      </div>
                    </div>
                    <div className="flex justify-between items-center gap-10">
                      {/* <div className="flex items-center gap-10 csb1">
                         <CiCirclePlus className="cursor-pointer csb1-icon" />
                        <h3 className="csb1-no">
                          Quantity :{" "}
                          {bookDetail.item && bookDetail.item.quantity}
                        </h3>
                        {/* <CiCircleMinus className="cursor-pointer csb1-icon" />
                      </div> */}
                      <div className="flex items-center gap-10 csb1">
                        <CiCircleMinus
                          onClick={() => decrementQuantity()}
                          className="cursor-pointer csb1-icon"
                        />
                        <h3
                          style={{ userSelect: "none" }}
                          className="quantity csb1-no"
                        >
                          {bookDetail.item && bookDetail.item.quantity}
                        </h3>
                        <CiCirclePlus
                          onClick={() => incrementQuantity()}
                          className="cursor-pointer csb1-icon"
                        />
                      </div>
                      <div className="flex items-center gap-10 csb1p2">
                        <h3 className="csb1p2-price">
                          {/* Price: {currencySymbol} */}
                          Price: {currency}{" "}
                          {bookDetail &&
                            bookDetail.item &&
                            bookDetail.item.priceTotal &&
                            formatPrice(bookDetail.item.priceTotal, currency)}
                          /-
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w-full flex flex-col items-between cs-box2">
                  <div className="mb-auto">
                    <div className="w-full flex items-center justify-between mb-[5%] gap-5 csb2">
                      <h1 className="w-[60%] sm:w-[50%] md:w-[40%] lg:w-[90%] xl:w-[57%] csb2-title">
                        Payment details
                      </h1>
                      <div className="w-full csb2-line"></div>
                    </div>
                    <div className="w-full mb-[2%] payment-details">
                      <div className="w-full flex justify-between pd-item">
                        <h1 className="w-max">Item</h1>
                        <h2 className="w-max">
                          {bookDetail &&
                            bookDetail.paymentDetail &&
                            bookDetail.paymentDetail.item}
                        </h2>
                      </div>
                    </div>
                    <div className="w-full mb-[2%] payment-details">
                      <div className="w-full flex justify-between pd-item">
                        <h1 className="w-max">Subtotal</h1>
                        <h2 className="w-max">
                          {/* {currencySymbol} */}
                          {currency}{" "}
                          {bookDetail &&
                            bookDetail.paymentDetail &&
                            bookDetail.paymentDetail.subTotal &&
                            formatPrice(bookDetail.paymentDetail.subTotal, currency)}
                          /-
                        </h2>
                      </div>
                    </div>
                    <div className="w-full mb-[2%] payment-details">
                      <div className="w-full flex justify-between pd-item">
                        <h1 className="w-max">GST @ 18%</h1>
                        <h2 className="w-max">
                          {/* {currencySymbol} */}
                          {currency}{" "}
                          {bookDetail &&
                            bookDetail.paymentDetail &&
                            bookDetail.paymentDetail.GST &&
                            formatPrice(bookDetail.paymentDetail.GST, currency)}
                          /-
                        </h2>
                      </div>
                    </div>
                    {bookDetail &&
                      bookDetail.paymentDetail &&
                      bookDetail.paymentDetail.discount && (
                        <div className="w-full mb-[2%] payment-details">
                          <div className="w-full flex justify-between pd-item">
                            <h1 className="w-max">Discount</h1>
                            <h2 className="w-max">
                              {/* {currencySymbol} */}
                              {currency}{" "}
                              {formatPrice(bookDetail.paymentDetail.discount, currency)}
                              /-
                            </h2>
                          </div>
                        </div>
                      )}
                    <div className="w-full mb-[5%] payment-details">
                      <div className="w-full flex justify-between pd-item pd-item2">
                        <h1 className="w-max">Grand total</h1>
                        <h2 className="w-max">
                          {/* {currencySymbol} */}
                          {currency}{" "}
                          {bookDetail &&
                            bookDetail.paymentDetail &&
                            bookDetail.paymentDetail.grandTotal &&
                            formatPrice(bookDetail.paymentDetail.grandTotal, currency)}
                          /-
                        </h2>
                      </div>
                    </div>
                  </div>
                  {/* <Link to="/books/payment"> */}
                  <div className="w-full flex pay-button">
                    <button
                      className="w-full py-[5%] btn-pay"
                      onClick={handleProceedToPay}
                    >
                      Process to pay
                    </button>
                  </div>
                  {/* </Link> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BooksSingleBilling;
